import { randomBytes } from "crypto"


export const generateRandomString = (length: number = 10) => {
  const buffer = randomBytes(length)
  return buffer.toString('hex')
}

export const generateUUID = () => {
  return window?.crypto?.randomUUID?.() ?? generateRandomString(10)
}

export const generateRequestId = () => {
  return generateUUID() ?? generateRandomString(10)
}